import {$} from '../jquery-definition.js';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
import 'flickity-bg-lazyload';
import '@fancyapps/fancybox';
import {animateInViewport} from "../transition";

// make Flickity a jQuery plugin
Flickity.setJQuery( $ );
jQueryBridget( 'flickity', Flickity, $ );

var $imageCarousel = $( '.image-carousel' ).flickity( {
	bgLazyLoad: 2,
	pageDots: true,
	prevNextButtons: true,
	selectedAttraction: 0.01,
	friction: 0.2,
	wrapAround: true,
	arrowShape: {
		x0: 20,
		x1: 60,
		y1: 40,
		x2: 70,
		y2: 40,
		x3: 30,
	},
} );

$imageCarousel.on( 'change.flickity', function( event, index ) {
	var $this = $( this );

	var $textCarousel = $( $this.attr( 'data-text-carousel' ) );

	if ( $textCarousel ) {
		$textCarousel.flickity( 'select', index );
	}

	var $enlarge = $( $this.attr( 'data-enlarge' ) );

	$enlarge.attr( 'href', $this.find( '.carousel-cell' ).eq( index ).attr( 'data-image' ) );
} );

var $textCarousel = $( '.text-carousel' ).flickity( {
	pageDots: false,
	prevNextButtons: false,
	draggable: false,
	wrapAround: true,
} );

var $headerImageCarousel = $( '.header-image-carousel' ).flickity( {
	bgLazyLoad: 2,
	pageDots: true,
	prevNextButtons: true,
	selectedAttraction: 0.01,
	friction: 0.2,
	wrapAround: true,
	arrowShape: {
		x0: 20,
		x1: 60,
		y1: 40,
		x2: 70,
		y2: 40,
		x3: 30,
	},
} );

$headerImageCarousel.on( 'change.flickity', function( event, index ) {
	var $this = $( this );

	var $enlarge = $( $this.attr( 'data-enlarge' ) );

	$enlarge.attr( 'href', $this.find( '.carousel-cell' ).eq( index ).attr( 'data-image' ) );

	var uiTheme = $this.find( '.carousel-cell' ).eq( index ).attr( 'data-ui-theme' );
	if ( uiTheme ) {
		$( '.header-image-carousel-container' ).attr( 'data-ui-theme', uiTheme );
	}
} );

$( '.header-image-carousel .carousel-cell' ).each( function( index ) {
	var $this = $( this );

	var image = $this.attr( 'data-image' );

	isItDark( image, function( darkornot ) {
		$this.attr( 'data-ui-theme', (darkornot) ? 'light' : 'dark' );

		if ( index === 0 ) {
			$( '.header-image-carousel-container' ).attr( 'data-ui-theme', (darkornot) ? 'light' : 'dark' );
		}
	} );
} );

$( window ).resize( function() {
	setTimeout( function() {
		$imageCarousel.flickity( 'reposition' );
		$headerImageCarousel.flickity( 'reposition' );
	}, 100 );
} );


function isItDark( imageSrc, callback ) {
	var fuzzy = 0.1;
	var img = document.createElement( "img" );
	img.src = imageSrc;
	img.style.display = "none";
	document.body.appendChild( img );

	img.onload = function() {
		// create canvas
		var canvas = document.createElement( "canvas" );
		canvas.width = this.width;
		canvas.height = this.height;

		var ctx = canvas.getContext( "2d" );
		ctx.drawImage( this, 0, 0 );

		var imageData = ctx.getImageData( 0, 0, canvas.width, canvas.height );
		var data = imageData.data;
		var r,
			g,
			b,
			max_rgb;
		var light = 0,
			dark = 0;

		for ( var x = 0, len = data.length; x < len; x += 4 ) {
			r = data[ x ];
			g = data[ x + 1 ];
			b = data[ x + 2 ];

			max_rgb = Math.max( Math.max( r, g ), b );
			if ( max_rgb < 128 )
				dark++;
			else
				light++;
		}

		var dl_diff = ((light - dark) / (this.width * this.height));
		if ( dl_diff + fuzzy < 0 )
			callback( true ); /* Dark. */
		else
			callback( false );  /* Not dark. */
	};
}

$( '.swiper-image-carousel' ).each( function() {
	const $this = $( this );

	const swiperConfig = {
		loop: false,
		slidesPerView: 1,
		spaceBetween: 8,
		grabCursor: true,
		speed: 600,
		effect: 'fade',
	};

	const swiper = new Swiper( this, swiperConfig );

	$this.parents( '.swiper-container' ).find( '[data-goto-slide]' ).on( 'click', function() {
		const slide = $( this ).data( 'goto-slide' );
		swiper.slideTo( slide );

		$( this ).addClass( 'bg-sand' ).siblings().removeClass( 'bg-sand' );
	} );
} );

$( '.posts-carousel' ).each( function() {
	const $this = $( this );

	const swiperConfig = {
		loop: false,
		navigation: {
			nextEl: $this.parents( '.carousel-container' ).find( '.carousel-next' )[ 0 ],
			prevEl: $this.parents( '.carousel-container' ).find( '.carousel-previous' )[ 0 ],
		},
		slidesPerView: .75,
		spaceBetween: 20,
		grabCursor: true,
		speed: 600,
		freeMode: true,
		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween: 24,
			},
		},
	};

	const swiper = new Swiper( this, swiperConfig );

	swiper.on( 'slideChange slideChangeTransitionEnd', function() {
		animateInViewport();
	} );
} );

$( function() {
	let $links = $( '.destination-carousel .destination-carousel-link' );  // Select all the links with the class `.block`
	let $images = $( '.destination-carousel .destination-carousel-image' );
	let activeIndex = 0;               // Start with the first link
	let isFirstRun = true;             // Flag to check if it's the first iteration
	let isAnimating = false;           // Flag to prevent multiple animations at once

	// Initial setup: hide all images except the first one
	$images.hide().eq( activeIndex ).show();

	function showNextLink() {
		// Prevent animation from running if it's already running
		if ( isAnimating ) return;

		isAnimating = true;

		// Hide all descriptions and reset all progress bars if it's not the first run
		if ( !isFirstRun ) {
			$links.find( '.description' ).stop( true, true ).slideUp( 300 );
		}
		$links.find( '.progress-bar' ).css( 'width', '0' );  // Reset all progress bars initially

		// Show description of the current active link
		let $currentLink = $links.eq( activeIndex );

		// Only slide down if it's not the first run; otherwise, just show
		if ( isFirstRun ) {
			$currentLink.find( '.description' ).stop( true, true ).show();  // Directly show the first description
			isFirstRun = false;  // Turn off the first-run flag after the first iteration
		} else {
			$currentLink.find( '.description' ).stop( true, true ).slideDown( 300 );  // Slide down for subsequent items
		}

		// Fade out the current image and fade in the next image
		$images.stop( true, true ).fadeOut( 500 );  // Stop any ongoing fade and queue a new fadeOut
		$images.eq( activeIndex ).stop( true, true ).fadeIn( 500 );  // Fade in the next image

		// Animate the progress bar width to full over 5 seconds
		$currentLink.find( '.progress-bar' ).stop( true, true ).animate( { width: '100%' }, 5000, 'linear', function() {
			// Reset progress bar for the current link after animation completes
			$( this ).css( 'width', '0' );
		} );

		// Move to the next link after 5 seconds
		setTimeout( function() {
			// Move to the next index (loop back to 0 if we reach the end)
			activeIndex = (activeIndex + 1) % $links.length;

			// Allow next animation to run
			isAnimating = false;

			// Show the next link
			showNextLink();
		}, 5000 );
	}

	// Start the loop
	showNextLink();
} );
